/// <amd-module name="typeahead/features/HotelSuggestionUrlModifier" />
/// <amd-dependency path="jquery" name="$"/>

/// <reference path="../../typings/typeahead/IPageLoadHandler.d.ts" />

import {SubmitClickedMessage} from "typeahead/core/message/SubmitClickedMessage";
import {TypeaheadMessage} from "typeahead/core/message/TypeaheadMessage";
import * as ExecutionHelper from "typeahead/core/plugins/ExecutionHelper";
import {IStripingConfiguration} from "typeahead/core/StripingConfiguration";
import {TypeaheadUtils} from "typeahead/core/TypeaheadUtils";

const configuration: IStripingConfiguration[] = [
    {
        clients: ["Homepage", "AWSHomepage"],
        tabs: ["hotel"],
    },
    {
        clients: ["HotelsLandingPage"],
        tabs: ["hotel", undefined], // tab is undefined in SF slim wizard
    },
];

export class HotelSuggestionUrlModifier implements IPageLoadHandler {

    public handlePageLoad(options: any, context: IContext): void {
        TypeaheadMessage.subscribe(
            SubmitClickedMessage.getTopic(),
            (topic: string, message: SubmitClickedMessage) => {
                context.tab = this.getMercuryWzdTab();
                context.clientId = TypeaheadUtils.getClientId();
                if (ExecutionHelper.shouldExecute(context, configuration)) {
                    // Grab the tab input field for the relevant tab
                    const tabInputField: JQuery = $("[data-gcw-storeable-name=gcw-destination]:visible");

                    const selectedHotelIdElemId: string = "#" + $(tabInputField).attr("data-hotel_id_element");
                    const relevantCityNameElemId: string = "#" + $(tabInputField).attr("data-city_element");

                    const selectedHotelIdElem: JQuery = $(selectedHotelIdElemId);
                    const selectedHotelId: string = $(selectedHotelIdElem).val();
                    const relevantCityNameElem: JQuery = $(relevantCityNameElemId);
                    const relevantCityName: string = $(relevantCityNameElem).val();

                    if (selectedHotelId && relevantCityName) {
                        // Add the name attribute to the city input and
                        // remove the name attribute from destination input
                        $(relevantCityNameElem).attr("name", "destination");
                        $(tabInputField).removeAttr("name");
                    } else {
                        // Add the name attribute to the destination input and
                        // remove the name attribute from city input
                        $(tabInputField).attr("name", "destination");
                        $(relevantCityNameElem).removeAttr("name");
                    }
                }
            });
    }

    private getMercuryWzdTab() {
        return $("li.tab:visible").children("button.on").data("lob");
    }

}
